import { ApiResponse } from "apisauce";
import { Api } from "../api/api";
import { TGeneralApiResponse } from "../api/api-problem";
import { IResponseSnapshot } from '../../models';

/**
* # Terms Api 서비스
* 
* 서비스의 설명을 작성하세요.
* 
* ## 사용방법
* 
* ```ts
* const service = new TermsApi();
* 
* ```
*/
export class TermsApi {
  private BASE_URL = '/terms';

  private api: Api;

  constructor(api: Api) {
    this.api = api;
    this.api.setup();
  }

  /** 약관 조회 */
  async getTermsList(termsType: string, cdssType: string): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}?termsType=${termsType}&cdssType=${cdssType}`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}